import Client from '@avcan/utils/api/clients/incidents'
import * as Config from './config'

export default new Client(Config.incidents)
